import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import './WayBillPage.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  getFilterData,
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getWayBillData } from '../reducer';
import { WAY_BILL_MODULE } from '../../../configs/moduleNames';
import { loadWayBill } from '../actions';
import Pagination from '../../../components/base/Pagination/Pagination';
import WayBillDTO from '../../../dto/WayBillDTO';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import wayBillColumns from './wayBillColumns';
import { POPUP_LIST_NAME } from '../../../configs';
import { addGlobalPopUpWrapper, closeAllPopupWrapper } from '../../InformationScreenWrapper/actions';
import getDefaultSort from '../../../utils/getDefaultSort';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function WayBillPage(props) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get('search');
  const waybill_id = searchParams.get('waybill_id');
  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingWayBillList,
    wayBillList = [],
    wayBillListMeta,
  } = useSelector(getWayBillData);
  const filterName = 'waybill-filter';
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData(filterName, {}) });

  const DTO = new WayBillDTO();
  const attributes = DTO.getAttributesByName();

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[WAY_BILL_MODULE].wayBillListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: filterData,
      sort,
    };
    const p1 = dispatch(loadWayBill(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => loadData({ page: 1 }));
    return () => subscription.unsubscribe();
  }, [watch]);
  useEffect(() => setValue('search', search), [search]);

  const [sort, setSort] = useState(getDefaultSort(wayBillColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => {
    if (waybill_id) {
      dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.WAY_BILL_DETAIL, id: waybill_id })));
    }
  }, [waybill_id]);

  useEffect(() => { loadData(); }, [sort]);

  useEffect(() => () => dispatch((closeAllPopupWrapper())), []);

  const moreFormatter = (_, item) => null;

  return (
    <div className="page way-bill-page">
      <TimerLoader loading={loadingWayBillList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.waybill' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputProps={{
              value: search || '',
              onChange: e => setSearchParams(e.target.value ? { search: e.target.value || '' } : {}),
            }}
          />
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={attributes.waybill_valid_from_date}
            usePortal
            changeFormat="YYYY-MM-DD"
            className="no-border"
          />
          <div className="filter-sep" />
          <Button
            variant="second"
            className=""
            onClick={() => {
              setOpenFilter(true);
            }}
          ><Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.WAYBILL}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={wayBillList}
                columns={wayBillColumns}
                onDoubleClickByRow={item => {
                  dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.WAY_BILL_DETAIL, id: item?.id })));
                }}
                changeSort={changeSort}
                settingsFormatter={moreFormatter}
                sort={sort}
                name="waybill-filter"
                rowClassFormatter={rowClassFormatter}
              />
            </div>
          </div>
          <Pagination meta={wayBillListMeta} list={wayBillList} handleChangeMeta={loadData} />
        </div>
      </div>
    </div>
  );
}
